module.exports = __webpack_public_path__ + "static/media/biocant_logo.89af3ef8.svg";